import { call, put, takeLatest } from "redux-saga/effects";
import {
  callUrlStoreGetApi,
  callUrlStorePostApi,
} from "../Context/urlStoreApi";
import {
  onGetUrlData,
  onGetUrlDataError,
  onGetUrlDataSuccess,
  onPostUrlData,
  onPostUrlDataError,
  onPostUrlDataSuccess,
} from "../Store/Slices/urlStoreSlice";

function* PostUrlData({ payload }) {
  try {
    const postUrlDataResponse = yield call(callUrlStorePostApi, payload);
    if (postUrlDataResponse.httpStatusCode === "200") {
      yield put(
        onPostUrlDataSuccess({
          postData: postUrlDataResponse.response,
          message: postUrlDataResponse.errorMessage,
          status_code: postUrlDataResponse.httpStatusCode,
        })
      );
    } else {
      yield put(
        onPostUrlDataError({
          data: postUrlDataResponse.response,
          message: postUrlDataResponse.errorMessage,
          status_code: postUrlDataResponse.httpStatusCode,
        })
      );
    }
  } catch (error) {
    const message =
      error.response.data.errorMessage || "Something went wrong";
    yield put(onPostUrlDataError({ data: [], message, status_code: 400 }));
  }
}
function* GetUrlData() {
  try {
    const getUrlDataResponse = yield call(callUrlStoreGetApi);
    if (getUrlDataResponse.httpStatusCode === "200") {
      yield put(
        onGetUrlDataSuccess({
          getData: getUrlDataResponse.response,
          message: getUrlDataResponse.errorMessage,
          status_code: getUrlDataResponse.httpStatusCode,
        })
      );
    } else {
      yield put(
        onGetUrlDataError({
          getData: getUrlDataResponse.response,
          message: getUrlDataResponse.errorMessage,
          status_code: getUrlDataResponse.httpStatusCode,
        })
      );
    }
  } catch (error) {
    const message =
      error.response.data.errorMessage || "Something went wrong";
    yield put(onGetUrlDataError({ data: [], message, status_code: 400 }));
  }
}
export default function* urlStoreSaga() {
  yield takeLatest(onPostUrlData.type, PostUrlData);
  yield takeLatest(onGetUrlData.type, GetUrlData);
}
